module.exports = __webpack_public_path__ + "img/u99.2b9efcd3.png";